import React, { useCallback, useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { Modal } from 'react-bootstrap'
import { getPlayerGameHistoryGanamos, getSportsBetsGanamos } from '../../../../../../Api/UserPanel/UserPanel'
import { BiLoaderCircle } from 'react-icons/bi'
import { SingleTransfer } from '../../../../../../Api/UserPanel/models'
import { useGetPlayerCoinHistoryGanamos } from '../../../../../../Hooks/Users/useGetPlayerCoinHistoryGanamos'
import { formatUTCtoArgentinaTime } from '../../../../../../../Utils/Utils'

interface Props {
    show: boolean
    onHide: () => void
    form: {
        name: string
    }
}

enum StatusOptions {
    Ganado = '1',
    Perdido = '2',
    Reembolso = '3',
    Deposito = '4',
    Retiro = '5',
    Bonificacion = '6'
}

enum SportsBetsStatusOptions {
    Ganado = 'GANADO',
    Perdido = 'PERDIDO',
    Pending = 'PENDIENTE'
}


export const PlayerGameHistoryGanamos = ({ show, onHide, form }: Props) => {
    const [playerGameHistory, setPlayerGameHistory] = useState<any | null>(null)
    const [playerSportsBetsHistory, setPlayerSportsBetsHistory] = useState<any | null>([])

    const [selectedStatus, setSelectedStatus] = useState<StatusOptions>(StatusOptions.Ganado)
    const [loading, setLoading] = useState(false)

    const getGameHistory = useCallback(async () => {
        setLoading(true)
        const response = await getPlayerGameHistoryGanamos({ name: form?.name?.trim(), status: selectedStatus })
        const responseSportsBets = await getSportsBetsGanamos({ name: form?.name?.trim(), page: 0 })
        setPlayerGameHistory(response.data)
        if (responseSportsBets?.data?.result?.items && responseSportsBets?.data?.result?.items?.length > 0) {
            setPlayerSportsBetsHistory(responseSportsBets?.data?.result?.items)
        }
        setLoading(false)
    }, [form?.name, selectedStatus])



    useEffect(() => {
        getGameHistory()
    }, [getGameHistory])


    const getStatusColor = (status: string) => {
        if (String(status) === StatusOptions.Ganado) return 'green'
        if (String(status) === StatusOptions.Perdido) return 'red'
        if (String(status) === StatusOptions.Reembolso) return 'orange'
        if (String(status) === StatusOptions.Deposito) return 'blue'
        if (String(status) === StatusOptions.Retiro) return 'blue'
        if (String(status) === StatusOptions.Bonificacion) return 'blue'
    }



    const getStatusLabel = (status: StatusOptions) => {
        if (String(status) === StatusOptions.Ganado) return 'Ganado'
        if (String(status) === StatusOptions.Perdido) return 'Perdido'
        if (String(status) === StatusOptions.Reembolso) return 'Reembolso'
        if (String(status) === StatusOptions.Deposito) return 'Depósito'
        if (String(status) === StatusOptions.Retiro) return 'Retiro'
        if (String(status) === StatusOptions.Bonificacion) return 'Bonificación'
    }


    const { playerCoinHistory, loading: loadingCoinHistory } = useGetPlayerCoinHistoryGanamos({ form })

    const getHistoryColor = (e: SingleTransfer) => {
        if (e?.operation === 1) { return 'red' }
        if (e?.operation === 0) { return 'green' }
        if (e?.operation === 2) { return 'orange' }
        return '';
    }

    const getHistoryLabel = (e: SingleTransfer) => {
        if (e?.operation === 1) { return 'Descarga' }
        if (e?.operation === 0) { return 'Carga' }
        if (e?.operation === 2) { return 'Bonificación' }
        return '';
    }


    const filteredHistory = playerCoinHistory?.data?.result?.transfers?.filter((item: any) => item?.to_user?.toLowerCase() === form.name.toLowerCase()) ?? []

    const formattedCoinHistory = filteredHistory?.map((item: any) => ({
        id: item?.id,
        amount: item?.amount,
        status: item?.operation === 1 ? StatusOptions.Retiro : item?.operation === 0 ? StatusOptions.Deposito : StatusOptions.Bonificacion,
        provider: item?.operation === 1 ? 'Retiro' : item?.operation === 0 ? 'Depósito' : 'Bonificación',
        date: formatUTCtoArgentinaTime(item?.created_at),
        note: '',
        balance_before: '',
        balance_after: '',
        user_id: 'admin',
        username: '',
        gameType: ''
    })) ?? [];


    // const formattedSportsBetsHistory = playerSportsBetsHistory?.map((item: any) => ({
    //     id: item?.id,
    //     amount: item?.amount,
    //     status: item?.operation === 'WON' ? SportsBetsStatusOptions.Ganado : item?.operation === 'LOST' ? SportsBetsStatusOptions.Perdido : SportsBetsStatusOptions.Pending,
    //     provider: item?.provider,
    //     date: formatUTCtoArgentinaTime(item?.created_at),
    //     note: '',
    //     balance_before: '',
    //     balance_after: '',
    //     user_id: 'admin',
    //     username: '',
    //     gameType: ''
    // })) ?? [];


    const formattedGameHistory = Array.isArray(playerGameHistory) ? playerGameHistory?.map((item: any) => ({
        ...item,
        date: new Date(new Date(item.date).getTime() - 3 * 60 * 60 * 1000).toLocaleString(),
    })) : [];

    const bothArraySortedByDate = [...formattedCoinHistory, ...formattedGameHistory]?.sort((a: any, b: any) => new Date(b.date).getTime() - new Date(a.date).getTime())

    return (
        <Modal show={show} onHide={onHide} size='xl'>
            <Modal.Header closeButton>
                <Modal.Title>Historial de Juego {form.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <div className='text-primary d-flex justify-content-between mb-3'>
                    Historial de cargas de los ultimos 30 días
                </div>

                {/* <div className='d-flex justify-content-center'>
                    {loadingCoinHistory && <div className='d-flex justify-content-center my-5 gap-2 align-items-center'>
                        <div className='spin-animation d-flex align-items-center justify-content-center'>
                            <BiLoaderCircle size={20} />
                        </div>
                        <span>Cargando...</span>
                    </div>}
                    {!loadingCoinHistory && <div>
                        {filteredHistory?.map((item: any) => (
                            <div key={item.id}>
                                <div style={{ color: getHistoryColor(item) }} className="d-flex gap-2">
                                    <span>[{formatUTCtoArgentinaTime(item.created_at)}]</span>
                                    <span>{item.to_user}</span>
                                    <span>{item.amount}</span>
                                    <span>({getHistoryLabel(item)})</span>
                                </div>
                            </div>
                        ))}
                    </div>}
                </div> */}



                <span>Últimos 10.000 registros de juego</span>
                {loading && <div className='d-flex justify-content-center my-5 gap-2 align-items-center'>
                    <div className='spin-animation d-flex align-items-center justify-content-center'>
                        <BiLoaderCircle size={20} />
                    </div>
                    <span>Cargando...</span>
                </div>}

                {!loading && playerGameHistory && (
                    <>
                        <div className='d-flex justify-content-end mb-3 w-100 align-items-center gap-2'>
                            <select value={selectedStatus} className='form-select w-50' onChange={(e) => setSelectedStatus(e.target.value as StatusOptions)}>
                                <option value={StatusOptions.Ganado}>Ganado</option>
                                <option value={StatusOptions.Perdido}>Perdido</option>
                                <option value={StatusOptions.Reembolso}>Reembolso</option>

                            </select>
                        </div>
                        <div className="table-responsive overflow-auto" style={{ height: '500px' }}>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Fecha</th>
                                        <th>Proveedor</th>
                                        <th>Importe</th>
                                        <th>Saldo Anterior</th>
                                        <th>Saldo Posterior</th>
                                        <th>Estado</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {Array.isArray(bothArraySortedByDate) && bothArraySortedByDate?.map((entry: any, index: number) => (
                                        <tr
                                            key={index}
                                            style={{ backgroundColor: entry.user_id === 'admin' ? 'black' : '' }}
                                            className={`${entry.user_id === 'admin' ? 'text-warning' : ''}`}
                                        >
                                            <td>{entry.date}</td>
                                            <td>{entry.provider}</td>
                                            <td>{entry.amount}</td>
                                            <td>{entry.balance_before}</td>
                                            <td>{entry.balance_after}</td>
                                            <td style={{ color: getStatusColor(entry.status) }}>{getStatusLabel(entry.status)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {
                                Array.isArray(bothArraySortedByDate) && bothArraySortedByDate?.length === 0 && <div className='d-flex justify-content-center my-5'>
                                    <span>No hay historial</span>
                                </div>
                            }
                        </div>
                    </>

                )}


                <hr />
                {Array.isArray(playerSportsBetsHistory) && playerSportsBetsHistory?.length > 0 && !loading &&
                    <div>
                        <div className='text-primary d-flex justify-content-between mb-3'>
                            <h5>Historial de Apuestas Deportivas</h5>
                        </div>
                        <div className="table-responsive overflow-auto" style={{ height: '500px' }}>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Fecha</th>
                                        <th>Tipo</th>
                                        <th>Proveedor</th>
                                        <th>Cantidad</th>
                                        <th>Resultado</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {Array.isArray(playerSportsBetsHistory) && playerSportsBetsHistory?.map((entry: any, index: number) => (
                                        <tr
                                            key={index}
                                            style={{ backgroundColor: entry.user_id === 'admin' ? 'black' : '' }}
                                            className={`${entry.user_id === 'admin' ? 'text-warning' : ''}`}
                                        >
                                            <td>{formatUTCtoArgentinaTime(entry.created_at)}</td>
                                            <td>{entry.type}</td>
                                            <td>{entry.provider}</td>
                                            <td>{entry.amount}</td>
                                            <td style={{ color: entry.status === 'WON' ? 'green' : entry.status === 'LOST' ? 'red' : 'orange' }}>{entry.status === 'WON' ? SportsBetsStatusOptions.Ganado : entry.status === 'LOST' ? SportsBetsStatusOptions.Perdido : SportsBetsStatusOptions.Pending}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        {
                            Array.isArray(playerSportsBetsHistory) && playerSportsBetsHistory?.length === 0 && <div className='d-flex justify-content-center my-5'>
                                <span>No hay historial</span>
                            </div>
                        }
                    </div>
                }
            </Modal.Body>
            <Modal.Footer>

                <Button variant="secondary" onClick={onHide}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>)
}
